@if (mainFilename$ | async; as mainFilename) {
  <custom-dashboard
    *axLazyElement="'dashboard/' + mainFilename"
    [dispatcher]="globalEventDispatcher">
  </custom-dashboard>
}
